import React from 'react';
import c from 'classnames';
import Immutable from 'immutable';

import ImageWithIllustration from '../Image/WithIllustration';


import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
} from '../../config/constants';

const FullWidthImage = ({ imagePostion, entity, isVerticalLayout }) => {
  return (
    <div
      className={
        c('image', 'js-parallax', {
        'offset-lg-1': imagePostion === 'right' && entity.get('field_text').size > 0,
        'col-md-5': entity.get('field_text').size > 0 && !isVerticalLayout,
        'col-md-12': !entity.get('field_text').size > 0,
        'col-md-10': isVerticalLayout,
        'mx-auto': isVerticalLayout,
        'col-12': isVerticalLayout,
      })
      }
    >
      <ImageWithIllustration
        image={entity.getIn(['field_image', 0], Immutable.Map())}
        crops={Immutable.Map({
          [SCREEN_MOBILE]: 'cropped_standard_medium_viewport',
          [SCREEN_NORMAL]: 'crop_standard',
        })}
      />
    </div>
  );
};

export default FullWidthImage;
